<div class="center logo">
    <img src="/assets/Biohof_Huama_Logo_mitHintergrund.webp"/>
</div>